import { callApi, getCommonHeaders } from '../authConfig';
import CryptoJS from 'crypto-js';

const encryptData = (data, secretKey = 'default-key') => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return { encryptedPayload: ciphertext };
};

export const secureApiCall = async (
  endpoint,
  method = 'post',
  data = {},
  useEncryption = false,
  customHeaders = {}
) => {

  const payload = useEncryption ? encryptData(data) : data;

  const headers = {
    ...getCommonHeaders(),
    ...customHeaders
  };

  try {
    const response = await callApi(endpoint, method, payload, headers);
    const responseData = response?.data ?? response;
    const responseStatus = response?.status;
    const hasData = Object.prototype.hasOwnProperty.call(responseData || {}, "data");

    //NORMALIZACIÓN PRO DE RESPUESTA
    return {
      success: responseData?.success ?? true,
      code: responseData?.code ?? responseStatus,
      message: responseData?.message ?? "",
      data: hasData ? responseData.data : responseData,
      raw: response
    };

  } catch (error) {
    console.error('Error en secureApiCall:', error);

    // MANEJO INTELIGENTE DE ERRORES CON RESPONSE
    if (error?.response) {
      const errorData = error.response.data;

      return {
        success: errorData?.success ?? false,
        code: errorData?.code ?? error.response.status,
        message: errorData?.message ?? "Error del servidor",
        data: errorData?.data ?? null,
        raw: error.response
      };
    }

    //ERROR REAL (network, timeout, etc)
    return {
      success: false,
      code: "500",
      message: "Error de conexión con el servidor",
      data: null
    };
  }
};
